import { User } from "./models";

export const ApiResult = {
  NONE: 0,
  SUCCESS: 1,
  ALREADY_EXIST: 2,
  NOT_EXIST: 3,
  NO_PERMISSION: 4,
  INTERNAL_ERROR: 5,
  UNKNOWN_ERROR: 6,
};

export const LoadingStatus = {
  NONE: 0,
  PENDING: 1,
  FULFILLED: 2,
  REJECTED: 3,
};

export const MenteeMenu = {
  NONE: -1,
  HOME: 0,
  TEST: 1,
  SEARCH: 2,
  MENTOR: 3,
  INVENTORY: 4,
};

export const MentorMenu = {
  HOME: 0,
  MENTEE: 1,
  SEARCH: 2,
};

export const ScoreType = {
  NONE: 0,
  JOB_CAPABILITY_WITHIN: 1,
  JOB_CAPABILITY_BETWEEN: 2,
  JOB_CAPABILITY_LEVEL_WITHIN: 3,
  JOB_CAPABILITY_LEVEL_BETWEEN: 4,
  KNOWLEDGE_WITHIN: 5,
  KNOWLEDGE_BETWEEN: 6,
  KNOWLEDGE_LEVEL_WITHIN: 7,
  KNOWLEDGE_LEVEL_BETWEEN: 8,
  ENVIRONMENT_WITHIN: 9,
  ENVIRONMENT_BETWEEN: 10,
  CHARACTER_WITHIN: 11,
  CHARACTER_BETWEEN: 12,
  INTEREST_WITHIN: 13,
  INTEREST_BETWEEN: 14,
  VALUES_WITHIN: 15,
  VALUES_BETWEEN: 16,
  ACTIVITY_WITHIN: 17,
  ACTIVITY_BETWEEN: 18,
  ACTIVITY_LEVEL_WITHIN: 19,
  ACTIVITY_LEVEL_BETWEEN: 20,
};

export const ScoreTitle: string[] = [
  "업무수행능력 (직업내)",
  "업무수행능력 (직업간)",
  "업무수행능력수준 (직업내)",
  "업무수행능력수준 (직업간)",
  "지식중요도 (직업내)",
  "지식중요도 (직업간)",
  "지식중요도수준 (직업내)",
  "지식중요도수준 (직업간)",
  "환경중요도 (직업내)",
  "환경중요도 (직업간)",
  "성격중요도 (직업내)",
  "성격중요도 (직업간)",
  "흥미중요도 (직업내)",
  "흥미중요도 (직업간)",
  "가치관중요도 (직업내)",
  "가치관요도 (직업간)",
  "업무활동 중요도 (직업내)",
  "업무활동 중요도 (직업간)",
  "업무활동수준 중요도 (직업내)",
  "업무활동수준 중요도 (직업간)",
];

export const SimpleScoreTitle: string[] = [
  "업무능력",
  "업무능력",
  "업무능력",
  "업무능력",
  "지식",
  "지식",
  "지식",
  "지식",
  "환경",
  "환경",
  "성격",
  "성격",
  "흥미",
  "흥미",
  "가치관",
  "가치관",
  "업무활동",
  "업무활동",
  "업무활동",
  "업무활동",
];

// StageType에서 화면에 표시할 스테이지
export const DisplayStages = [0, 4, 5, 6, 7];

export const StageName: string[] = [
  "접촉없음",
  "접촉완료",
  "방문약속",
  "방문완료",
  "견적요청",
  "계약완료",
  "준비완료",
  "수업완료",
  // "계산서신청완료",
  // "계산서발급완료",
  // "입금완료",
];

export const StageType = {
  NONE: 0,
  CONTACT: 1, // 전화연락
  VISIT_APPOINTMENT: 2, // 방문약속
  VISIT: 3, // 방문완료
  ESTIMATE: 4, // 견적요청
  CONTRACT_COMPLETED: 5, // 계약완료
  CLASS_ASSIGNED: 6, // 수업할당
  CLASS_COMPLETED: 7, // 수업완료
  // TAX_BILL_REQUEST: 8, // 계산서 신청완료
  // TAX_BILL_COMPLETED: 9, // 계산서 발급완료
  // PAYMENT_COMPLETED: 10, // 입금완료
};

// [수업추가시]
export const ClassNames: string[] = [
  "창업",
  "창직",
  "인공지능",
  "경제",
  "진학",
];

// [수업추가시]
export const LectureType = {
  startup: 1,
  makejob: 2,
  ai: 3,
  economy: 4,
  university: 5,
  startupCompetition: 6,
};

export type StaticLectureClass = {
  type: number;
  name: string;
  description: string;
  thumbnail: string;
};

export const staticLectureClass: StaticLectureClass[] = [
  {
    type: LectureType.startup,
    name: "AI 창업수업",
    description: "인공지능과 항께 창업에서 코스닥 상장까지 경험해보세요",
    thumbnail: "/images/lectures/startup.jpg",
  },
  {
    type: LectureType.startupCompetition,
    name: "AI 창업경진대회",
    description: "[AI 창업수업]과 IR 발표 행사, 상장식까지 경험해보세요",
    thumbnail: "/images/lectures/startup-competition.jpg",
  },
  {
    type: LectureType.makejob,
    name: "창직수업",
    description: "미래의 새로운 직업을 만들어 보세요",
    thumbnail: "/images/lectures/makejob.jpg",
  },
  {
    type: LectureType.ai,
    name: "인공지능 수업",
    description: "인공지능과 함께 살아가는 법을 배워보세요",
    thumbnail: "/images/lectures/ai.jpg",
  },
  {
    type: LectureType.economy,
    name: "경제수업",
    description: "경제의 눈으로 나의 미래와 세상에 대한 이해를 해보세요",
    thumbnail: "/images/lectures/economy.jpg",
  },
  {
    type: LectureType.university,
    name: "진학수업",
    description: "진학에 대해 '미리 알았더라면 좋았을 것'들을 체험해보세요.",
    thumbnail: "/images/lectures/university.jpg",
  },
];

export enum SchoolType {
  NONE = 0,
  ELEMENTARY = 1,
  MIDDLE = 2,
  HIGH = 3,
  UNIVERSITY = 4,
  ORGANIZATION = 10,
}

export const RegionNames: string[] = ["서울", "경기", "인천"];

export const schoolTypeName = [
  "",
  "초",
  "중",
  "고",
  "대",
  "",
  "",
  "",
  "",
  "ka",
  "관",
];

export enum UserRole {
  GUEST = 0,
  USER = 10,
  MANAGER = 50,
  ADMIN = 100,
}

export enum StudentRole {
  NORMAL = 0,
  REGISTER = 1, // 모둠의 결과 등록
  EVALUATOR = 2, // 심사위원
}

export type LoginUser = {
  email: string;
  password: string;
};

export type UserPassword = {
  user: User;
  password: string;
  newMode: boolean;
};

export type Sort = "contract_date" | "class_date" | "name" | "region" | "stage";
export type Order = "asc" | "desc";

export const DisplayYears = [2024, 2025, 2026];

export interface YearCnt {
  year: number;
  cnt: number;
}

// 유입경로
export enum FunnelType {
  NONE = 0,
  RENEWAL = 1,
  SNS = 2,
  RECOMMEND = 3,
  LECTURE = 4,
  SEARCH = 5,
  TEXT = 6,
  EMAIL = 7,
  ETC = 8,
}

export const FunnelNames: string[] = [
  "재계약",
  "SNS",
  "추천",
  "강의",
  "검색",
  "문자",
  "이메일",
  "기타",
];

export interface Estimate {
  id: number;
  classType: number;
  schoolName: string;
  classTimes: number;
  contractCnt: number;
  classDate: Date;
  teacherName: string;
  teacherEmail: string;
  teacherPhone: string;
  funnels: string;
  agreeTerms: boolean;
  agreePrivacy: boolean;
  agreeAd: boolean;
  price: number;
  isIncludeLunch: boolean;
  launchMinutes: number;
  requestClassTimeFrom: string;
  requestClassTimeTo: string;
  adminStaffEmail: string;
  adminStaffPhone: string;
  adminStaffName: string;
  isRequestEstimate: boolean;
  requestEstimateDateTime: Date;
  isCreateDocument: boolean;
  isSendEmail: boolean;
  isSendSms: boolean;
  isConfirmSchool: boolean;
  isNeedSendConfirmSms: boolean;
  timeToSendConfirmSms: Date;
  isAgreeContract: boolean;
  isApplyCompleted: boolean;
  isContractComplete: boolean;
  schoolSalesId: number;
  isFree: boolean;
}
